const translations = {
	label: "Portail investisseur",
	detail: "Dossier rempli par votre client sur le portail investisseur.",
	tooltip: "Dossier rempli par le client sur le portail investisseur",
	reference: "Référence",
	submitted_at: "Envoyé le",
};

export default translations;
